import {
  Autocomplete,
  Checkbox,
  Chip,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { TemplateCategory } from "../../../../enums/TemplateCategory";

export const CATEGORY_OPTIONS = Object.values(TemplateCategory);

export default function TemplateCategoryMultiSelect({
  value = [],
  onChange,
  size = "small",
}) {
  const { t } = useTranslation();
  const safeValue = Array.isArray(value) ? value : [];

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      size={size}
      options={CATEGORY_OPTIONS}
      value={safeValue}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      getOptionLabel={(option) => t(option) || ""}
      isOptionEqualToValue={(o, v) => o === v}
      renderOption={(propsInner, option, { selected }) => {
        return (
          <li {...propsInner} key={option}>
            <ListItemIcon style={{ minWidth: 32 }}>
              <Checkbox
                edge="start"
                checked={selected}
                tabIndex={-1}
                disableRipple
                size="small"
              />
            </ListItemIcon>
            <ListItemText
              id={`category-list-label-${option}`}
              primary={t(option)}
            />
          </li>
        );
      }}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip key={option} label={t(option)} size="small" {...tagProps} />
          );
        })
      }
      renderInput={(params) => {
        const { InputProps, ...otherParams } = params;
        const { startAdornment } = InputProps;

        return (
          <TextField
            {...otherParams}
            label={t("AddCategories")}
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment:
                safeValue.length > 0 ? (
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    useFlexGap
                    sx={{ maxHeight: "100px", overflowY: "auto" }}
                  >
                    {startAdornment}
                  </Stack>
                ) : null,
            }}
          />
        );
      }}
      clearText={t("Clear")}
      closeText={t("Close")}
      openText={t("Open")}
    />
  );
}
